import React from 'react';
import ConditionDetailLayout from './ConditionDetailLayout';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import NotFound from '../../NotFound/index.jsx';
import ConditionAddOn from '../ConditionAddOn';
import './index.scss';

const ConditionDetail = props => {
  let repos;
  if (
    typeof window !== 'undefined' &&
    typeof __INITIAL_DATA__ !== 'undefined'
  ) {
    repos = window.__INITIAL_DATA__;
  } else {
    repos = props.staticContext !== 'undefined' && props.staticContext.data;
  }

  return !_.isEmpty(repos.error) || repos.message === 'condition not found' ? (
    <NotFound />
  ) : (
    <main>
      {repos.isSymptomsCauses ? (
        <ConditionAddOn data={repos} location={props.location} />
      ) : (
        <ConditionDetailLayout
          condition={repos && repos.condition}
          slugType={repos.slugType}
        />
      )}
    </main>
  );
};

export default withRouter(ConditionDetail);
